// @ flow <== can't activate on this file
// @TODO fix
import uniq from '../../utils/uniq';
import actionTypes from '../../actions/actionTypes';

type Classify = (data: any) => string|number;
type Filter = (data: any) => boolean;
type State = any;

export function classifyData(data: Object[], classify: Classify) {
  const classifiedData = {};
  data.forEach(d => {
    const key = classify(d);
    classifiedData[key] = classifiedData[key] || [];
    classifiedData[key].push(d);
  });
  return classifiedData;
}

export function addData(data: Object[], state: State, classify?: Classify): State {
  if (data.length === 0) {
    return state;
  }

  if (!classify) {
    return uniq([...data.map(d => d.id), ...state]);
  }

  const classifiedData = classifyData(data, classify);
  const result = {};
  Object.entries(classifiedData).forEach(
    ([key, value]) => result[key] = addData(value, state[key] || [])
  );

  return { ...state, ...result };
}

export function removeData(data: Object[], state:State, classify?: Classify) {
  if (data.length === 0) {
    return state;
  }

  if (!classify) {
    return uniq([...data.map(d => d.id), ...state])
      .slice(data.length);
  }

  const classifiedData = classifyData(data, classify);
  const result = {};
  const keyToDelete = [];
  Object.entries(classifiedData).forEach(([key, value]) => {
    result[key] = removeData(value, state[key] || []);

    if (result[key].length === 0) {
      keyToDelete.push(key);
    }
  });

  const newState = { ...state, ...result };
  keyToDelete.forEach(key => delete newState[key]);

  return newState;
}

export default (dataName: string, filter: Filter = () => true, classify: Classify) => {
  const defaultState = classify ? {} : [];
  return (state: State = defaultState, action:any) => {
    switch (action.type) {
      case actionTypes.LOG_OUT:
      case actionTypes.PROFILE_DELETE:
        return defaultState;
      default:
        break;
    }

    const data = action && action.data && action.data[dataName] || {};

    const dataToAdd: any[] = Object.values(data)
      .filter(d => d.isTemporary && filter(d));
    const dataToDelete: any[] = (action && action.dataToDelete && action.dataToDelete[dataName] || [])
      .filter(d => d.isTemporary && filter(d));

    const reducedState = removeData(dataToDelete, state, classify);
    return addData(dataToAdd, reducedState, classify);
  };
};



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/temporaryData/temporaryDataReducerGenerator.js